<div class="clr-row">
  <div
    *ngFor="let link of links"
    class="clr-col-lg-4 clr-col-12">
    <a [routerLink]="link.route" class="card clickable">
      <div class="card-block">
        <p class="card-text">
          {{ link.title }}
        </p>
      </div>
    </a>
  </div>
</div>
